import React, {useState, setState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Avatar, Button, Paper, Grid, Typography, Container, TextField} from '@material-ui/core';
import {GoogleLogin} from 'react-google-login';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import useStyles from './styles';
import Input from './Input';
import Icon from './icon';
import {signin, signup} from '../../actions/auth';

const initialState = {firstName: '', lastName: '', email: '', password: '', confirmPassword: ''};


const Auth = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [showPassword, setshowPassword] = useState(false);
    const [isSignup, setisSignup] = useState(false);
    const [formData, setFormData] = useState(initialState);
    const history = useHistory();
    const handleSubmit = (event) =>{
        event.preventDefault();
        if(isSignup){
            dispatch(signup(formData, history))
        } else{
            dispatch(signin(formData, history))
        }
    };
    const handleChange = (e) =>{
        setFormData({...formData, [e.target.name]: e.target.value});
    };
    const handleShowPassword = () => setshowPassword((prevshowPassword) => !prevshowPassword);
    const switchMode = () => {
        setisSignup((previsSignup) => !previsSignup);
        //handleShowPassword(false);
        setshowPassword(false);
    };
    const googleSuccess = async (res) =>{
        const result = res?.profileObj;
        const token = res?.tokenId;
        try{
            dispatch({type: 'AUTH', data: {result, token}});
            history.push('/');
        } catch (error){
            console.log(error);
        }
    };
    const googleFailure = (error) =>{
        console.log("Google Sign In was unsuccessful. Try Again Later.")
    };
    return (
        <Container component = "main" maxWidth = "xs">
            <Paper className = {classes.paper} elevation = {3}>
                <Avatar className = {classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography variant = "h5">{isSignup ? "Sign Up" : "Sign In"}</Typography>
                <form className = {classes.form} onSubmit = {handleSubmit}>
                    <Grid container spacing = {2}>
                        {
                            isSignup && (
                                <>
                                        <Input name = "firstName" label = "First Name" handleChange = {handleChange} autoFocus half />
                                        <Input name = "lastName" label = "Last Name" handleChange = {handleChange} half />  
                                </>
                            ) 
                        }
                        <Input name = "email" label = "Email Address" handleChange = {handleChange} type = "email" />
                        <Input name = "password" label = "Password" handleChange = {handleChange} type = {showPassword ? "text" : "password"} handleShowPassword = {handleShowPassword}/>
                        {isSignup && <Input name = "confirmPassword" label = "Repeat Password" handleChange = {handleChange} type = "password"/>}
                    </Grid>
                    
                    <Button type = "submit" fullWidth variant = "contained" color = "primary" className = {classes.Submit}> 
                        {isSignup ? "Sign Up" : "Sign In"}
                    </Button>
                    <GoogleLogin 
                        clientId = "161816614932-ll452t6u42mvahf2erclj4jb04la0k6i.apps.googleusercontent.com"
                        render = {(renderProps) => (
                            <Button 
                                className = {classes.googleButton} 
                                color = "primary" 
                                fullWidth 
                                onClick = {renderProps.onClick} 
                                disabled = {renderProps.disabled} 
                                startIcon = {<Icon />} 
                                variant = "contained">
                                  Google Sign In  
                            </Button>
                        )}
                        onSuccess = {googleSuccess}
                        onFailure = {googleFailure}
                        cookiePolicy = "single_host_origin"
                    />
                    <Grid container justify = "flex-end">
                            <Grid item>
                                <Button onClick = {switchMode}>
                                    {isSignup ? "Already have an account? Sign In" : "Don't have an account? Sign Up"}
                                </Button>
                            </Grid>
                    </Grid>
                </form>
            </Paper>
        </Container>
        );
};

export default Auth
